import {
  throwError as observableThrowError,
  Observable,
  Subscription,
} from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { secret, dadosModulo, Version } from "app/app.env";
import { routes } from "environments/environment";
import { AppLoaderService } from "./app-loader/app-loader.service";
import { AppConfirmService } from "./app-confirm/app-confirm.service";
import { LocalStorageService } from "ngx-webstorage";
import { Router } from "@angular/router";
import { Company } from "app/keys.env";
import { Logo } from "app/logo.env";
import { ModalService } from "./components/modal/modal.service";
import { ModalData } from "./components/modal/modal.interface";
import { AppContractsComponent } from "./app-contracts/app-contracts.component";
import { AppCodeConfirmComponent } from "./app-code-confirm/app-code-confirm.component";

@Injectable()
export class LoginService implements OnDestroy {
  private msg = "Aguarde, carregando contratos.";
  public contractsSubscription: Subscription;
  public tokenUnS: Subscription;
  constructor(
    private http: HttpClient,
    private loader: AppLoaderService,
    private confirm: AppConfirmService,
    private modalService: ModalService,
    private localStorage: LocalStorageService,
    private router: Router
  ) {}
  _contracts(comp) {
    const cpfCnpj = comp.rForm.value.cpfCnpj.replace(/[^\d]+/g, "");
    const keyusercompany = comp.rForm.value.keyUserCompany;

    dadosModulo["cpfCnpj"] = cpfCnpj;
    dadosModulo["keyUserCompany"] = keyusercompany;
    try {
      this.contractsSubscription = this.getContracts({
        keyusercompany,
        cpfCnpj,
      }).subscribe(
        (res) => {
          try {
            this.showMeContracts(res);
          } catch (e) {
            throw res;
          }
        },
        (err) => {
          comp.rForm.patchValue({ cpfCnpj: "" });
          const formValues = comp.rForm.value;
          comp.rForm.reset();
          comp.rForm.setValue(formValues);
          comp.valid = false;
          this.throwMistake(err);
        }
      );
    } catch (error) {
      this.throwMistake(error);
    }
  }

  showMeContracts(data) {
    try {
      data.forEach((element) => {
        const contratos = [];

        const { connection } = element;

        element.contracts.forEach((data: any) => {
          const {
            office,
            codeCobra,
            numberContract,
            statusContract,
            debtor,
            atende,
            collectionPortfolio,
          } = data;

          // console.log("tamanho", data.length);
          // console.log("contracts", data);

          const contract = {
            name: office.corporateName,
            logoImagem: Logo(office.logoImagem),
            codeCobra,
            numberContract,
            status: statusContract.name,
            keyUserCompany: connection.keyUserCompany,
            fantasia: office.name,
            activeTwoFactor: atende.twoFactorAuthentication.active,
            methodToSendCodeTwoFactor:
              atende.twoFactorAuthentication.nameMethodToSendCode,
            collectionPortfolio: {
              name: collectionPortfolio.name,
              companyName: collectionPortfolio.company.name,
              productName: collectionPortfolio.product.name,
            },
          };

          contract["debtor"] = debtor;
          contratos.push(contract);
        });

        const a = {};

        if (contratos.length === 1) {
          this.localStorage.store("contracts", false);

          // apresentar tela 2 fatores se estiver parametrizado na carteira do contrato
          if (contratos[0].activeTwoFactor === true) {
            // CODE A2F
            const modalData: ModalData = {
              component: AppCodeConfirmComponent,
              data: contratos[0],
            };

            // Abrir tela para obter a chave duplo fator
            const modal = this.modalService.openModal(modalData);
            modal.afterClosed().subscribe((form) => {
              const keyValid = form.codeValid;

              if (keyValid !== undefined && keyValid !== null) {
                // se chave ok seguir com o token
                if (keyValid) {
                  this._token(contratos[0], null, contratos); //TODO: Tirar o comentário dessa linha
                }
              }
            });
          } else {
            this._token(contratos[0], null, contratos); //TODO: Tirar o comentário dessa linha
          }
        } else {
          const modalData: ModalData = {
            component: AppContractsComponent,
            data: contratos,
          };

          const modal = this.modalService.openModal(modalData);

          modal.afterClosed().subscribe((value) => {
            if (value.contract !== undefined && value.contract !== null) {
              this.localStorage.store("contracts", true);

              // apresentar tela 2 fatores se estiver parametrizado na carteira do contrato
              if (value.contract.activeTwoFactor === true) {
                // CODE A2F
                const modalData: ModalData = {
                  component: AppCodeConfirmComponent,
                  data: value.contract,
                };

                // Abrir tela para obter a chave duplo fator
                const modal = this.modalService.openModal(modalData);
                modal.afterClosed().subscribe((form) => {
                  const keyValid = form.codeValid;

                  if (keyValid !== undefined && keyValid !== null) {
                    // se chave ok seguir com o token
                    if (keyValid) {
                      this._token(value.contract, null, contratos); //TODO: Tirar o comentário dessa linha
                    }
                  }
                });
              } else {
                this._token(value.contract, null, contratos); //TODO: Tirar o comentário dessa linha
              }

              // this._token(value.contract, null, contratos);
            }
          });
          // this.localStorage.store("contracts", true);
          // this.contracts.open(contratos);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  getContracts({ keyusercompany, cpfCnpj }): Observable<any> {
    this.loader.open("Aguarde, verificando os dados.");
    try {
      //console.log(`url que retorna os dados ${routes.searches_contracts2}`);

      cpfCnpj = this.padLeft(cpfCnpj, 14, 0);

      return this.http
        .get(
          `${routes.searches_contracts2}&keyusercompany=${keyusercompany}&cpfcnpj=${cpfCnpj}`
        )
        .pipe(
          map((res: any) => {
            this.loader.close();
            try {
              return res.data;
            } catch (error) {
              throw res;
            }
          }),
          catchError((error) => {
            this.loader.close();
            return observableThrowError(error);
          })
        );
    } catch (error) {
      return observableThrowError(error);
    }
  }

  _token(_contract, dialogRef?, contracts?, auth?) {
    this.loader.open(this.msg);

    dadosModulo["keyUserCompany"] = _contract.keyUserCompany
      ? _contract.keyUserCompany
      : this.localStorage.retrieve(secret.userData).keyUserCompany;

    return this.http.post(`${routes.login}`, dadosModulo).subscribe(
      (res) => {
        this._localStorage(res, _contract, auth);

        dialogRef ? dialogRef.close() : "";
      },
      (err) => {
        this.loader.close();
        this.throwMistake(err, this.confirm);
      }
    );
  }

  tokenLink(params) {
    try {
      this.loader.open(this.msg);

      const { keyUserCompany, codeCobra } = params;

      this.localStorage.store(secret.tsDebtor, btoa(keyUserCompany));

      let contract = {
        codeCobra,
        keyUserCompany,
      };

      /**
       * dados de envio
       */
      let route = routes.login;
      let body = {
        keyUI: "yaXf4qGwJr",
        ModuleUI: "app-debtor",
        VersionUI: Version,
        IpUI: "",
        keyUserCompany: keyUserCompany,
      };

      this.tokenUnS = this.http.post(route, body).subscribe((result) => {
        //console.log(result);
        this._localStorage(result, contract);
        this.tokenUnS.unsubscribe();
      });
    } catch (error) {
      console.error(error);
    }
  }

  findEscritorioByUserKeyCompany = function (UserKeyCompany: string) {
    const obj = Company[UserKeyCompany.trim()]
      ? Company[UserKeyCompany.trim()]
      : "TS-COBRA";
    return obj;
  };

  getCurrentCodeCobra() {
    return this.localStorage.retrieve(secret.userData).codeCobra;
  }

  generalParameters(codecobra) {
    return this.http
      .get(`${routes.parameters}?codecobra=${codecobra}&codeoperator=ts-atende`)
      .pipe(
        map((res: any) => {
          try {
            return res.data.atende;
          } catch (error) {
            throw error;
          }
        }),
        catchError((error) => {
          return observableThrowError(error);
        })
      );
  }

  _localStorage(_token, contract, auth?) {
    try {
      const codeCobra = contract.codeCobra;
      const keyUserCompany = contract.keyUserCompany
        ? contract.keyUserCompany
        : this.localStorage.retrieve(secret.userData).keyUserCompany;
      const localStorageData = {
        token: _token.data.token,
        codeCobra: codeCobra,
        keyUserCompany: keyUserCompany,
        numberContract: contract["numberContract"],
      };

      this.wLs(secret.userData, localStorageData).then(
        (res) => {
          this.generalParameters(codeCobra).subscribe(
            (res) => {
              this.wLs(secret.parameters, res).then((res) => {
                this.router
                  .navigate(["/painel/" + keyUserCompany])
                  .then(() => this.loader.close());
              });
            },

            (err) => console.error("errrrr", err)
          );
        },
        (err) => {
          this.loader.close();
          this.throwMistake(err);
        }
      );

      if (auth) {
        window.location.reload();
      }
    } catch (error) {
      this.loader.close();
      this.throwMistake(error);
    }
  }

  async wLs(key, data) {
    try {
      let ls = await this.localStorage.store(key, data);
      return ls;
    } catch (error) {
      throw error;
    }
  }

  async wLsRetrieve(key) {
    try {
      return await this.localStorage.retrieve(secret.parameters);
    } catch (error) {
      throw error;
    }
  }

  throwMistake(err, confirm?: AppConfirmService) {
    const message = err.error.result
      ? err.error.result.message || err.message
      : err.message || err.message;
    const title = "";
    const login = true;

    const data = {
      title,
      message,
      login,
    };
    this.confirm.confirm(data);
  }

  ngOnDestroy() {
    if (this.contractsSubscription) {
      this.contractsSubscription.unsubscribe();
    }
  }
  padLeft(value, length, simbol) {
    var str = String(value);

    while (str.length < length) {
      str = simbol + str;
    }

    return str;
  }
}
